import { useTranslation } from "react-i18next";

function Banner() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 overflow-hidden md:py-28 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-[#f5272b] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#f5272b] rounded-full blur-3xl"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="overflow-hidden border shadow-2xl bg-gradient-to-r from-slate-800/90 to-slate-900/90 backdrop-blur-sm rounded-3xl border-slate-700/50">
            <div className="grid items-center grid-cols-1 gap-8 p-8 lg:grid-cols-2 md:p-12 lg:p-16">
              {/* Text Content */}
              <div className="space-y-6">
                <h2 className="text-3xl font-bold leading-tight text-white md:text-4xl lg:text-5xl">
                  {t("economical")} <span className="text-[#f5272b]">{t("big")}</span> {t("with_our_car")}
                </h2>
                <p className="text-lg leading-relaxed md:text-xl text-slate-300">
                  {t("top_airport")}{" "}
                  <span className="inline-block px-4 py-1.5 bg-[#f5272b] text-white font-semibold rounded-full text-base shadow-lg">
                    24/7
                  </span>{" "}
                  {t("support")}.
                </p>
              </div>

              {/* Visual Element */}
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-[#f5272b]/20 to-transparent rounded-2xl blur-2xl"></div>
                <div className="relative p-8 border bg-gradient-to-br from-slate-700/50 to-slate-800/50 rounded-2xl border-slate-600/50 backdrop-blur-sm">
                  <div className="space-y-4">
                    <div className="flex items-center space-x-4">
                      <div className="w-14 h-14 bg-[#f5272b] rounded-xl flex items-center justify-center shadow-lg">
                        <i className="text-2xl text-white fa-solid fa-car"></i>
                      </div>
                      <div className="flex-1 h-2 overflow-hidden rounded-full bg-slate-600/50">
                        <div className="h-full w-3/4 bg-gradient-to-r from-[#f5272b] to-red-600 rounded-full"></div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center justify-center border w-14 h-14 bg-slate-700 rounded-xl border-slate-600">
                        <i className="fa-solid fa-shield-halved text-[#f5272b] text-2xl"></i>
                      </div>
                      <div className="flex-1 h-2 overflow-hidden rounded-full bg-slate-600/50">
                        <div className="h-full w-full bg-gradient-to-r from-[#f5272b] to-red-600 rounded-full"></div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center justify-center border w-14 h-14 bg-slate-700 rounded-xl border-slate-600">
                        <i className="fa-solid fa-headset text-[#f5272b] text-2xl"></i>
                      </div>
                      <div className="flex-1 h-2 overflow-hidden rounded-full bg-slate-600/50">
                        <div className="h-full w-2/3 bg-gradient-to-r from-[#f5272b] to-red-600 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
